module.exports = __webpack_public_path__ + "static/media/sort-numeric-down-alt.e560e702.svg";